<rx-intuitive-treatment-viewlist-item-base
	[isIndicationVisible]="isIndicationVisible"
	[indicationId]="indicationId"
	[previewTitle]="previewTitle"
	[isInvalid]="item.isInvalid ?? false"
>
	<div class="rx-intuitive-tooth-treatment-viewlist-item__title" rxIntuitiveViewlistItemTitle>
		{{ 'ToothEditor.ToothNumberHash' | translate }}{{ toothNumberLabel }}
	</div>
	<div class="rx-intuitive-tooth-treatment-viewlist-item__preview-slot" rxIntuitiveViewlistItemPreview>
		<ng-container *ngIf="isImplantIndication && implantsSummaryLine; else standardPreview">
			<div class="rx-intuitive-tooth-treatment-viewlist-item__preview-implant">
				<div class="rx-intuitive-tooth-treatment-viewlist-item__preview-line rx-intuitive-tooth-treatment-viewlist-item__preview-line--implant-summary">
					<div class="rx-intuitive-tooth-treatment-viewlist-item__preview-line-text">{{ implantsSummaryLine }}</div>
				</div>
				<div *ngIf="hasCrownTreatmentPreview" class="rx-intuitive-tooth-treatment-viewlist-item__preview-line rx-intuitive-tooth-treatment-viewlist-item__preview-line--crown-preview">
					<div class="rx-intuitive-tooth-treatment-viewlist-item__preview-line-text">{{ previewLine }}</div>
				</div>
			</div>
		</ng-container>
		<ng-template #standardPreview
			><span class="rx-intuitive-tooth-treatment-viewlist-item__preview-line rx-intuitive-tooth-treatment-viewlist-item__preview-line--single">{{ previewLine }}</span></ng-template
		>
	</div>
</rx-intuitive-treatment-viewlist-item-base>
